/* eslint-disable import/prefer-default-export */
import superagent from "superagent";
import Cookies from "universal-cookie";
import { base_url } from "../../../../../utils/constants";

interface ResponseBody {
  status: boolean;
  message: string;
  data?: any;
}

interface Error {
  data: {
    message: string;
  };
}
type Dispatch = (arg: { type: string; payload: any }) => void;

const cookie = new Cookies();
const acceptHeaderValue = "application/json";

export const getData = (callback?: () => void, search?: string) => (dispatch: Dispatch) => {
  const searchQuery = search ? `&search=${search}` : "";
  return superagent
    .get(`${base_url}get-videos?page=1${searchQuery}`)
    .set("accept", acceptHeaderValue)
    .set("Authorization", cookie.get("user_token"))
    .end((err: Error, res: { body: ResponseBody }) => {
      callback?.();
      if (res) {
        if (res.body.status) {
          dispatch({ type: "GET_VIDEO_TUTORIALS", payload: res.body.data });
          // console.log("Data====>", res.body.data);
        } else {
          dispatch({ type: "THROW_ERROR", payload: res.body.message });
          if (res.body.message === "No videos or content found") {
            dispatch({ type: "CRUD_VIDEOS", payload: [] });
          }
        }
      } else {
        dispatch({ type: "THROW_ERROR", payload: err.data.message });
        dispatch({ type: "IS_LOADING", payload: false });
      }
    });
};

export const setSequence = (data: any) => (dispatch: Dispatch) => {
  return superagent
    .post(`${base_url}admin/update-video-sequence`)
    .set("accept", acceptHeaderValue)
    .set("Authorization", cookie.get("user_token"))
    .send(data)
    .end((err: Error, res: { body: ResponseBody }) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: "THROW_SUCCESS", payload: res.body.message });
        } else {
          dispatch({ type: "THROW_ERROR", payload: res.body.message });
        }
      } else {
        dispatch({ type: "THROW_ERROR", payload: err.data.message });
      }
    });
};

export const deleteVideo = (id: number | null, callback: any) => (dispatch: Dispatch) => {
  return superagent
    .delete(`${base_url}admin/delete-video/${id}`)
    .set("accept", acceptHeaderValue)
    .set("Authorization", cookie.get("user_token"))
    .end((err: Error, res: { body: ResponseBody }) => {
      dispatch(getData());
      callback();
      if (res) {
        if (res.body.status) {
          dispatch({ type: "THROW_SUCCESS", payload: res.body.message });
          dispatch({ type: "DELETE_VIDEO", payload: id });
        } else {
          dispatch({ type: "THROW_ERROR", payload: res.body.message });
        }
      } else {
        dispatch({ type: "THROW_ERROR", payload: err.data.message });
      }
    });
};

export const addVideo = (data: any, callback: any) => (dispatch: Dispatch) => {
  return superagent
    .post(`${base_url}admin/add-update-video`)
    .set("accept", acceptHeaderValue)
    .set("Authorization", cookie.get("user_token"))
    .send(data)
    .end((err: Error, res: { body: ResponseBody }) => {
      dispatch(getData());
      callback();
      if (res) {
        if (res.body.status) {
          dispatch({ type: "THROW_SUCCESS", payload: res.body.message });
        } else {
          dispatch({ type: "THROW_ERROR", payload: res.body.message });
        }
      } else {
        dispatch({ type: "THROW_ERROR", payload: err.data.message });
      }
    });
};

export const addContent = (data: any) => (dispatch: Dispatch) => {
  return superagent
    .post(`${base_url}admin/add-update-video-content`)
    .set("accept", acceptHeaderValue)
    .set("Authorization", cookie.get("user_token"))
    .send(data)
    .end((err: Error, res: { body: ResponseBody }) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: "THROW_SUCCESS", payload: res.body.message });
        } else {
          dispatch({ type: "THROW_ERROR", payload: res.body.message });
        }
      } else {
        dispatch({ type: "THROW_ERROR", payload: err.data.message });
      }
    });
};
